import { InputNumber, Slider, Space } from "antd"
import { memo } from "react"

interface AttributeEditorProps {
  title: string
  min: number
  max: number
  onChange?: (val: number) => void
  value: number
  step?: number
}

export const AttributeEditor = memo((props: AttributeEditorProps) => {
  const { title, min, max, value, onChange, step } = props
  return <Space>
    <label>{title}</label>
    <Slider value={value} min={min} max={max} onChange={onChange} step={step} style={{width: 240}} />
    <InputNumber value={value} min={min} max={max} onChange={(val) => onChange?.(val || 0)} style={{width: 80}} />
  </Space>
})